import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/privacy.scss";

function Privacy() {
  useEffect(() => {
    document.title = `Privacy policy | ${siteConfig.displayName}`;
  }, []);

  return (
    <main className="policy-page privacy-page">
      <nav className="legal-tabs" aria-label="Legal information">
        <Link className="is-active" to="/privacy">Privacy policy</Link>
        <Link to="/terms">Terms of use</Link>
        <Link to="/cookies">Cookie policy</Link>
        <Link to="/faqs">FAQs</Link>
      </nav>
      <header className="policy-heading">
        <p className="eyebrow">LEGAL</p>
        <h1>Privacy policy</h1>
        <p>Last modified: September 16, 2026</p>
      </header>
      <div className="policy-columns">
        <section>
          <h2>1. Your privacy matters</h2>
          <p>
            {siteConfig.displayName} uses only the information needed to provide
            the storefront experience, respond to inquiries, fulfil orders and
            remember choices you make on this device.
          </p>
          <h2>2. Information you provide</h2>
          <p>
            We may collect contact, delivery, order and payment confirmation data,
            along with messages you send to customer care. Payment card details are
            handled by the selected payment service and are not retained by us.
          </p>
          <h2>3. Local storage</h2>
          <p>
            Shopping cart and wishlist identifiers are stored locally so they can
            remain available after a refresh. You can clear them by removing your
            browser's site data or clearing the cart and wishlist in the interface.
          </p>
        </section>
        <section>
          <h2>4. How information would be used</h2>
          <p>
            Order details are used to fulfil a purchase, prevent fraud, provide
            support and meet accounting obligations. Marketing
            messages would require separate consent and always include an opt-out.
          </p>
          <h2>5. Your choices</h2>
          <p>
            Depending on your location, you may request access, correction,
            portability or deletion of personal information, or object to certain
            processing. We would verify a request before taking action.
          </p>
          <h2>6. Retention and security</h2>
          <p>We retain information only for as long as needed for the purposes described above, legal requirements and dispute resolution. Reasonable technical and organizational safeguards are used to protect it.</p>
          <h2>7. Contact</h2>
          <p>
            {siteConfig.companyName} operates {siteConfig.website.replace("https://", "")}. Questions about privacy can be sent to <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>.
            You can also write to {siteConfig.contact.address}.
          </p>
        </section>
      </div>
    </main>
  );
}

export default Privacy;
